import React, { useContext, useEffect, useRef, useState } from "react";
import { Card, Avatar, Text, Group, Button, Stack, Divider } from "@mantine/core";
import { IconMessageCircle, IconPlus, IconUserMinus, IconUserPlus, IconPencil } from "@tabler/icons-react";
import { MessageUser } from "../Dashbaord/DashboardPages/Members";

export function ProfileHeader({
  name,
  subtitle,
  followers = "",
  following = "",
  avatarUrl,
  userId,
  isFollowing = false,
  onFollowToggle,
  setChatId,
  hideActions = false,
}) {
  return (
    <Card withBorder={false} shadow="none" radius="0" aria-label="Profile header" p="xl">
      <Group align="flex-start" spacing="xl" noWrap>
        <Avatar
          src={avatarUrl}
          size={112}
          radius="xl"
          alt="Profile avatar"
          styles={{
            root: { border: "4px solid white", backgroundColor: "#e5e7eb" },
          }}
        />
        <Stack spacing="xs" style={{ flex: 1 }}>
          <h3>
            {name}
          </h3>
          {subtitle && (
            <Text>
              {subtitle}
            </Text>
          )}
          {(followers || following) && (
            <Group spacing="md" mt={4}>
              {followers && (
                <Text>
                  <b>{followers}</b> Followers
                </Text>
              )}
              {following && (
                <Text>
                  <b>{following}</b> Following
                </Text>
              )}
            </Group>
          )}
          {!hideActions && (
          <Group mt="md" spacing="sm">
            <MessageUser
              id={userId}
              setChatId={setChatId}
              size="sm"
              variant="outline"
              radius="sm"
              leftIconSize={18}
              // Custom brand outline color
              styles={{ root: { borderColor: "#3566fd", color: "#3566fd" } }}
            />
            <Button
              size="sm"
              color={isFollowing ? "gray" : "blue"}
              onClick={onFollowToggle}
              styles={!isFollowing ? { root: { backgroundColor: "#3566fd" } } : undefined}
              leftIcon={
                isFollowing ? (
                  <IconUserMinus size={18} color="white" />
                ) : (
                  <IconUserPlus size={18} color="white" />
                )
              }
            >
              {isFollowing ? "Unfollow" : "Follow"}
            </Button>
          </Group>
          )}

          {hideActions && (
            <Group mt="md" spacing="sm">
              <Button
                component="a"
                href="/dashboard/#/profile"
                size="sm"
                variant="outline"
                radius="sm"
                leftIcon={<IconPencil size={18} />}
                styles={{ root: { borderColor: "#3566fd", color: "#3566fd" } }}
              >
                Edit Profile
              </Button>
            </Group>
          )}
        </Stack>
      </Group>
      <Divider
        my="md"
        styles={{
          root: {
            backgroundColor: "#e5e7eb",
            opacity: 0.5,
          },
        }}/>
    </Card>
  );
}
